/**
 * Convert a string to a URL-friendly slug
 * Example: "The Great Gatsby" -> "the-great-gatsby"
 */
export function slugify(text: string): string {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')        // Replace spaces with -
    .replace(/[^\w-]+/g, '')     // Remove all non-word chars
    .replace(/-{2,}/g, '-');     // Replace multiple - with single -
}

/**
 * Generate a short 5-character alphanumeric ID from a longer ID
 */
export function generateShortId(longId: string): string {
  // Take first 5 alphanumeric characters from the ID
  return longId.replace(/[^a-zA-Z0-9]/g, '').slice(0, 5).toLowerCase();
}

/**
 * Create a book URL from title and ID
 * Format: /book/the-great-gatsby-a3b4c
 */
export function createBookUrl(title: string, id: string): string {
  const slug = slugify(title);
  const shortId = generateShortId(id);
  return `/book/${slug}-${shortId}`;
}

/**
 * Extract book ID from URL slug
 * Format: the-great-gatsby-a3b4c -> a3b4c (short ID)
 */
export function extractBookIdFromSlug(slug: string): string | null {
  const match = slug.match(/-([a-z0-9]{5})$/);
  return match ? match[1] : null;
}

/**
 * Extract book slug from URL (without short ID)
 * Format: the-great-gatsby-a3b4c -> the-great-gatsby
 */
export function extractBookSlug(slug: string): string {
  return slug.replace(/-[a-z0-9]{5}$/, '');
}
